export const SECTION_TITLES = {
    '3.1': 'Réassort et disponibilité',
    '3.2': 'Organisation et entretien du rayon/frigo',
    '3.3': 'Gestion des casses et invendus',
    '3.4': 'Mise en place ou suivi des actions promotionnelles',
}

/** Pourcentage arrondi, ou null si aucune réponse. */
export const pct = (oui, total) => (Number(total) > 0 ? Math.round((Number(oui) * 100) / Number(total)) : null)

/** Couleur selon le taux de réalisation (vert ≥ 80, orange ≥ 50, rouge sinon). */
export const colorForRate = (p) =>
    p === null || p === undefined ? '#9AA3B5' : p >= 80 ? '#2E9E5B' : p >= 50 ? '#E0A100' : '#D9483B'

export const formatPct = (p) => (p === null || p === undefined ? '–' : `${p}%`)
